import { parseToken } from './token';

/**
 * Given a JWT, check the `exp` claim in the payload.
 * @param jwt
 * @returns true if the JWT is expired or invalid; otherwise, false
 */
export const expired = (jwt: string) => {
  const payload = parseToken(jwt);
  if (payload && 'exp' in payload) {
    const expMs = payload.exp * 1000;
    return new Date().getTime() >= expMs;
  }

  return true;
};
